import { useEffect, useState } from 'react';
import { api } from './api.js';

// Same shape the backend relays (routes/company-settings.mjs previewOf): PNG or JPEG base64 only, never SVG or HTML.
const DATA_URL = /^data:image\/(?:png|jpeg);base64,[A-Za-z0-9+/]+={0,2}$/;

/**
 * The customer's own logo for the header, only when the customer admin approved it. One GET that any member of the
 * tenant (and an operator, including "View as client") may call: the server answers { available: true, url, width,
 * height } only when the admin saved the Branding choice with the logo on and a logo was detected (the default alone is
 * not approval), and the browser may cache the answer for 5 minutes. The image is a data URL validated in the customer's
 * account; it lives in component state only (never stored, never logged). Any failure returns null: no logo.
 *
 * @param {string|null} customerId the customer in scope, or null (All customers)
 * @param {boolean} enabled false while blocked
 * @returns {{ url: string, width: number, height: number }|null}
 */
export function useCustomerLogo(customerId, enabled) {
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    setLogo(null);
    if (!enabled || typeof customerId !== 'string' || customerId.length === 0) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const out = await api.companyLogo(customerId);
        if (!cancelled && out?.available === true && typeof out.url === 'string' && DATA_URL.test(out.url)) {
          setLogo({ url: out.url, width: out.width, height: out.height });
        }
      } catch {
        // No logo is a normal state, never an error in the header.
      }
    })();
    return () => { cancelled = true; };
  }, [customerId, enabled]);
  return logo;
}
